/* "Build Your Set": per-variant quantity table -> running subtotal -> one combined cart add. */
if (!customElements.get('build-your-set')) {
  class BuildYourSet extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onAdd = this.onAdd.bind(this);
    }

    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat || '';
      this.subtotalEl = this.querySelector('[data-bys-subtotal]');
      this.addButton = this.querySelector('[data-bys-add]');
      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onInput);
      if (this.addButton) this.addButton.addEventListener('click', this.onAdd);
      this.updateSubtotal();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.onInput);
      if (this.addButton) this.addButton.removeEventListener('click', this.onAdd);
    }

    onClick(event) {
      const minus = event.target.closest('[data-bys-minus]');
      const plus = event.target.closest('[data-bys-plus]');
      if (!minus && !plus) return;
      const stepper = event.target.closest('.build-your-set__stepper');
      const input = stepper && stepper.querySelector('[data-bys-qty]');
      if (!input || input.disabled) return;
      let value = parseInt(input.value, 10) || 0;
      value = plus ? value + 1 : Math.max(0, value - 1);
      input.value = value;
      this.updateSubtotal();
    }

    onInput(event) {
      if (!event.target.matches('[data-bys-qty]')) return;
      // Allow an empty field while typing; subtotalCents() already treats a blank input as 0.
      if (event.target.value !== '') {
        let value = parseInt(event.target.value, 10);
        if (isNaN(value) || value < 0) value = 0;
        event.target.value = value;
      }
      this.updateSubtotal();
    }

    rows() {
      return Array.from(this.querySelectorAll('[data-bys-qty]'));
    }

    subtotalCents() {
      return this.rows().reduce((sum, input) => {
        const qty = parseInt(input.value, 10) || 0;
        const price = parseInt(input.dataset.price, 10) || 0;
        return sum + qty * price;
      }, 0);
    }

    updateSubtotal() {
      const cents = this.subtotalCents();
      if (this.subtotalEl && window.FoxTheme && FoxTheme.Currency) {
        this.subtotalEl.textContent = FoxTheme.Currency.formatMoney(cents, this.moneyFormat);
      }
      if (this.addButton) this.addButton.disabled = cents === 0;
    }

    items() {
      return this.rows()
        .map((input) => ({ id: parseInt(input.dataset.variantId, 10), quantity: parseInt(input.value, 10) || 0 }))
        .filter((item) => item.quantity > 0 && !isNaN(item.id));
    }

    async onAdd() {
      const items = this.items();
      if (!items.length || this.adding) return;
      this.adding = true;
      this.addButton.classList.add('btn--loading');
      this.addButton.setAttribute('aria-disabled', 'true');
      try {
        const utils = window.FoxTheme && FoxTheme.utils;
        const routes = (window.FoxTheme && FoxTheme.routes) || {};
        const config = utils && typeof utils.fetchConfig === 'function' ? utils.fetchConfig('javascript') : { headers: {} };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // Collect the cart sections (drawer, icon) so their HTML re-renders on cartUpdate, exactly as
        // the theme's own add-to-cart does. Without this the drawer can't repaint and shows its empty state.
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        config.body = JSON.stringify({ items: items, sections: sectionsToBundle, sections_url: window.location.pathname });
        const response = await fetch(routes.cart_add_url || '/cart/add.js', config);
        const parsed = await response.json();
        if (parsed.status) {
          this.showError(parsed.description || parsed.message);
          return;
        }
        const cart = await (await fetch(routes.cart_url || '/cart.js', utils && typeof utils.fetchConfig === 'function' ? utils.fetchConfig() : {})).json();
        cart.sections = parsed.sections || {};
        if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
        this.reset();
        this.closeAndOpenCart();
      } catch (error) {
        console.warn('Build Your Set add failed', error);
      } finally {
        this.adding = false;
        this.addButton.classList.remove('btn--loading');
        this.addButton.removeAttribute('aria-disabled');
      }
    }

    reset() {
      this.rows().forEach((input) => {
        input.value = 0;
      });
      this.updateSubtotal();
    }

    closeAndOpenCart() {
      const modal = this.closest('basic-modal');
      if (modal && typeof modal.hide === 'function') modal.hide();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
    }

    showError(message) {
      const wrap = this.querySelector('.product-form__error-message-wrapper');
      const el = this.querySelector('.product-form__error-message');
      if (el && message) {
        el.textContent = message;
        if (wrap) wrap.hidden = false;
      }
    }
  }
  customElements.define('build-your-set', BuildYourSet);
}
